// extracted by mini-css-extract-plugin
export default {"containerParallax":"ContentParallax_containerParallax__Vy1Cg","containerScroller":"ContentParallax_containerScroller__NUVmR","image":"ContentParallax_image__Kt+-q"};